export default __webpack_public_path__ + "static/media/Group8918.8c878cf8.svg";